export const permissions = {
  owner: {
    card_holders: {
      read: true,
      write: true,
      delete: true,
    },
    order: {
      read: true,
      write: true,
      delete: true,
    },
    programs: {
      read: true,
      write: true,
      delete: true,
    },
    search_order: {
      read: true,
      write: true,
      delete: true,
    },
    sell_order: {
      read: true,
      write: true,
      delete: true,
    },
    void_sell_order_item_by_id: {
      read: true,
      write: true,
      delete: true,
    },
    batch_sell_order: {
      read: true,
      write: true,
      delete: true,
    },
    card_balance: {
      read: true,
    },
    replace_cards: {
      read: true,
      write: true,
      delete: true,
    },
    combine_cards: {
      read: true,
      write: true,
      delete: true,
    },
    shift_report: {
      read: true,
      write: true,
      delete: true,
    },
    kiosk_report: {
      read: true,
      write: true,
      delete: true,
    },
    office: {
      read: true,
      write: true,
      delete: true,
    },
    shipping_address: {
      read: true,
      write: true,
      delete: true,
    },
    report: {
      read: true,
    },
    settings: {
      read: true,
    },
    users: {
      read: true,
      write: true,
      delete: true,
    },
    program_reports: {
      read: true,
      write: true,
      delete: true,
    },
    audit_logs: {
      read: false,
    },
    corporate_customers: {
      read: false,
      write: false,
      delete: false,
    },
    sell_specialty_items: {
      read: true,
      write: true,
      delete: false,
    },
  },
  admin: {
    card_holders: {
      read: true,
      write: false,
      delete: false,
    },
    order: {
      read: true,
      write: true,
      delete: true,
    },
    programs: {
      read: true,
      write: true,
      delete: true,
    },
    search_order: {
      read: true,
      write: true,
      delete: true,
    },
    sell_order: {
      read: true,
      write: true,
      delete: true,
    },
    void_sell_order_item_by_id: {
      read: true,
      write: true,
      delete: true,
    },
    batch_sell_order: {
      read: true,
      write: true,
      delete: true,
    },
    card_balance: {
      read: true,
    },
    replace_cards: {
      read: true,
      write: true,
      delete: true,
    },
    combine_cards: {
      read: true,
      write: true,
      delete: true,
    },
    shift_report: {
      read: true,
      write: true,
      delete: true,
    },
    kiosk_report: {
      read: true,
      write: true,
      delete: true,
    },
    office: {
      read: true,
      write: true,
      delete: true,
    },
    shipping_address: {
      read: true,
      write: true,
      delete: true,
    },
    report: {
      read: true,
    },
    settings: {
      read: true,
    },
    users: {
      read: true,
      write: true,
      delete: true,
    },
    program_reports: {
      read: true,
      write: true,
      delete: true,
    },
    audit_logs: {
      read: true,
    },
    corporate_customers: {
      read: true,
      write: true,
      delete: true,
    },
    sell_specialty_items: {
      read: true,
      write: true,
      delete: false,
    },
  },
  client_admin: {
    card_holders: {
      read: false,
      write: false,
      delete: false,
    },
    order: {
      read: true,
      write: true,
      delete: true,
    },
    programs: {
      read: true,
      write: true,
      delete: true,
    },
    search_order: {
      read: true,
      write: true,
      delete: true,
    },
    sell_order: {
      read: true,
      write: true,
      delete: true,
    },
    void_sell_order_item_by_id: {
      read: true,
      write: true,
      delete: true,
    },
    batch_sell_order: {
      read: true,
      write: true,
      delete: true,
    },
    card_balance: {
      read: true,
    },
    replace_cards: {
      read: true,
      write: true,
      delete: true,
    },
    combine_cards: {
      read: true,
      write: true,
      delete: true,
    },
    shift_report: {
      read: true,
      write: true,
      delete: true,
    },
    kiosk_report: {
      read: true,
      write: true,
      delete: true,
    },
    office: {
      read: true,
      write: true,
      delete: true,
    },
    shipping_address: {
      read: true,
      write: true,
      delete: true,
    },
    reports: {
      read: true,
    },
    settings: {
      read: true,
    },
    users: {
      read: true,
      write: true,
      delete: true,
    },
    program_reports: {
      read: true,
      write: true,
      delete: true,
    },
    audit_logs: {
      read: true,
    },
    corporate_customers: {
      read: true,
      write: true,
      delete: true,
    },
    sell_specialty_items: {
      read: true,
      write: true,
      delete: false,
    },
  },
  office_admin: {
    card_holders: {
      read: false,
      write: false,
      delete: false,
    },
    order: {
      read: false,
      write: false,
      delete: false,
    },
    programs: {
      read: false,
      write: false,
      delete: false,
    },
    search_order: {
      read: true,
      write: false,
      delete: false,
    },
    sell_order: {
      read: true,
      write: true,
      delete: false,
    },
    void_sell_order_item_by_id: {
      read: true,
      write: true,
      delete: false,
    },
    batch_sell_order: {
      read: true,
      write: true,
      delete: false,
    },
    card_balance: {
      read: true,
    },
    replace_cards: {
      read: true,
      write: true,
      delete: true,
    },
    combine_cards: {
      read: true,
      write: true,
      delete: true,
    },
    shift_report: {
      read: true,
    },
    kiosk_report: {
      read: true,
    },
    office: {
      read: false,
      write: false,
      delete: false,
    },
    shipping_address: {
      read: false,
      write: false,
      delete: false,
    },
    reports: {
      read: true,
    },
    settings: {
      read: true,
    },
    users: {
      read: true,
      write: true,
      delete: true,
    },
    program_reports: {
      read: true,
      write: false,
      delete: false,
    },
    audit_logs: {
      read: true,
    },
    corporate_customers: {
      read: false,
      write: false,
      delete: false,
    },
    sell_specialty_items: {
      read: false,
      write: false,
      delete: false,
    },
  },
  agent: {
    card_holders: {
      read: false,
      write: false,
      delete: false,
    },
    order: {
      read: false,
      write: false,
      delete: false,
    },
    programs: {
      read: false,
      write: false,
      delete: false,
    },
    search_order: {
      read: true,
      write: false,
      delete: false,
    },
    sell_order: {
      read: true,
      write: false,
      delete: false,
    },
    void_sell_order_item_by_id: {
      read: false,
      write: false,
      delete: false,
    },
    batch_sell_order: {
      read: true,
      write: false,
      delete: false,
    },
    card_balance: {
      read: true,
    },
    replace_cards: {
      read: true,
      write: false,
      delete: false,
    },
    combine_cards: {
      read: true,
      write: true,
      delete: true,
    },
    shift_report: {
      read: true,
      write: false,
      delete: false,
    },
    kiosk_report: {
      read: true,
      write: false,
      delete: false,
    },
    office: {
      read: false,
      write: false,
      delete: false,
    },
    shipping_address: {
      read: false,
      write: false,
      delete: false,
    },
    reports: {
      read: false,
    },
    settings: {
      read: true,
    },
    users: {
      read: false,
      write: false,
      delete: false,
    },
    program_reports: {
      read: true,
      write: false,
      delete: false,
    },
    audit_logs: {
      read: true,
    },
    corporate_customers: {
      read: false,
      write: false,
      delete: false,
    },
    sell_specialty_items: {
      read: false,
      write: false,
      delete: false,
    },
  },
};
